import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class Step409063Meta extends BaseModel {
  /**
   * @var {bool}
   */
  hasSpecificDistributions;

  constructor(model = {}) {
    super();
    this.hasSpecificDistributions = model.hasSpecificDistributions;
  }
}
